import cleanDeep from 'clean-deep';
import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetProfileResponse } from './types/get-profile.type';

type GetProfileRequest = {
    action?: string | null;
};

export const getProfile = async ({
    action,
}: GetProfileRequest): Promise<AxiosResponse<GetProfileResponse>> => {
    const params = cleanDeep({
        action,
    });

    const response = await api.get('/account/profile', {
        params,
    });

    return response;
};
